// removed by extract-text-webpack-plugin
module.exports = {"wrapper-specify-size":"magazines_2ZnDL","ba-text":"magazines_JxGWP","vertical-icon":"magazines_1FSCQ","horizontal-icon":"magazines_2hmKi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/ContentEditor/editors/ImageContent/styles.scss
// module id = 1231
// module chunks = 1